import { MonthlyLimitHookReturn, TabItem } from '../interface/interface';
import MonthlyLimit from '../views/MonthlyLimits';
import Tabs from './Tabs';
import Loading from './Loading';
import useMonthlyLimitActions from '../hooks/useMonthlyLimitActions';
import { useContext, useEffect } from 'react';
import { UserContext } from '../context/userContext';

export default function MonthlyLimitTabs() {
  const [load, userDetail, dried, vape]: MonthlyLimitHookReturn =
    useMonthlyLimitActions();
  const { setActiveItem } = useContext(UserContext);

  useEffect(() => {
    setActiveItem('My Care Hub');
  }, []);

  const tabs: TabItem[] = [
    {
      id: 'tab1',
      label: 'Dried Cannabis Flower',
      component: (
        <MonthlyLimit
          type={'Dried Cannabis Flower'}
          userDetail={userDetail}
          products={dried.chartData}
          prescriptions={dried.prescriptions}
          unit={'g'}
        />
      ),
    },
    {
      id: 'tab2',
      label: 'Vape Cartridge',
      component: (
        <MonthlyLimit
          type={'Vape Cartridge'}
          userDetail={userDetail}
          products={vape.chartData}
          prescriptions={vape.prescriptions}
          unit={'g/ml'}
        />
      ),
    },
  ];

  if (load) return <Loading />;

  return (
    <div className="container-standard">
      <Tabs tabs={tabs} />
    </div>
  );
}
